/** @format */
import { errorServiceModule } from '../error-handler/legacy/errorService';
import { privatePersonInfoServiceModule } from '../service/privatePersonInfo.service';
import { chooseEmployeesModule } from './chooseEmployees.dir';
import responsibleAssessorTpl from './responsibleAssessor.tpl.html';

export const responsibleAssessorModule = 'sis-components.person.responsibleAssessor';

(function () {
    responsibleAssessorController.$inject = [
        '$scope',
        'commonPrivatePersonInfoService',
        '$q',
        'defaultPromiseHandler',
        'personNameService',
    ];
    angular
        .module(responsibleAssessorModule, [
            errorServiceModule,
            chooseEmployeesModule,
            privatePersonInfoServiceModule,
            'sis-components.service.personNameService',
        ])
        .directive('responsibleAssessor', responsibleAssessor)
        .controller('ResponsibleAssessorController', responsibleAssessorController);

    function responsibleAssessor() {
        return {
            restrict: 'E',
            scope: {
                finalEvaluations: '=',
                editMode: '=',
                editDisabled: '<',
                save: '&',
                reset: '&?',
                responsibleTeachers: '<',
                allowedRoles: '<',
                required: '=',
            },
            controller: 'ResponsibleAssessorController',
            controllerAs: 'ctrl',
            template: responsibleAssessorTpl,
            link: function (scope, element, attrs, requires) {
                scope.ctrl.element = element;

                scope.ctrl.init();
            },
        };
    }

    function responsibleAssessorController($scope, commonPrivatePersonInfoService, $q, defaultPromiseHandler, personNameService) {
        var ctrl = this;

        ctrl.saveResponsibleAssessors = saveResponsibleAssessors;

        ctrl.init = function () {
            ctrl.editMode = $scope.editMode;
            ctrl.editDisabled = $scope.editDisabled;
            ctrl.responsibleTeachers = filterResponsibleTeachers($scope.allowedRoles);
            ctrl.createTeacherNames();
            ctrl.required = $scope.required ? $scope.required : false;
        };

        function filterResponsibleTeachers(allowedRoles) {
            let responsibleTeachers = $scope.responsibleTeachers;
            if (allowedRoles) {
                responsibleTeachers = _.filter(responsibleTeachers, function (teacher) {
                    return _.indexOf(allowedRoles, teacher.roleUrn) !== -1;
                });
            }
            return responsibleTeachers;
        }

        ctrl.createTeacherNames = function () {
            $q.all(getPersonFullNames()).then(names => {
                ctrl.responsibleTeachersNames = names;
            });
        };

        ctrl.toggleEditMode = function () {
            ctrl.editMode = !ctrl.editMode;

            if (ctrl.editMode) {
                ctrl.saveResponsibleAssessors(_.compact(_.map(ctrl.responsibleTeachers, 'personId')));
            } else {
                if ($scope.reset) {
                    ctrl.responsibleTeachers = $scope.reset();
                    ctrl.createTeacherNames();
                } else {
                    ctrl.saveResponsibleAssessors([]);
                }
            }
        };

        function saveResponsibleAssessors(assessors) {
            _.forEach($scope.finalEvaluations, function (finalEvaluation) {
                finalEvaluation.responsibleAssessorPersons = assessors;
            });

            $scope.save();
        }

        function getPersonFullNames() {
            return _.map(ctrl.responsibleTeachers, teacher =>
                commonPrivatePersonInfoService
                    .findById(teacher.personId)
                    .then(person => personNameService.getFullName(person))
                    .catch(defaultPromiseHandler.loggingRejectedPromiseHandler),
            );
        }
    }
})();
